import * as React from 'react';
import { AppointmentsContext } from './appointmentsContext';
import appointmentsReducer from './appointmentsReducer';

export default function AppointmentsProvider({ children }) {

  const [state, dispatch] = React.useReducer(appointmentsReducer, { })

  const value = [state, dispatch];

  return (
    <AppointmentsContext.Provider value={ value }>
      { children }
    </AppointmentsContext.Provider>
  )
}